import { useState } from "react";

// Shared by Members' MemberCard and PackageManagement's row avatar — a `photo_url` existing
// doesn't mean it actually loads (stale URL, deleted file, ...), and an <img> with a broken
// src renders the browser's own broken-image icon instead of falling back. `onError` flips to
// the initials fallback instead, the same one already shown when there's no `photoUrl` at all.
const ClientAvatar = ({ photoUrl, initials, background, wrapperClassName, imgClassName }) => {
  const [broken, setBroken] = useState(false);
  const showPhoto = !!photoUrl && !broken;

  return (
    <div className={wrapperClassName} style={showPhoto ? undefined : { background }}>
      {showPhoto ? (
        <img src={photoUrl} alt="" className={imgClassName} onError={() => setBroken(true)} />
      ) : (
        initials || "?"
      )}
    </div>
  );
};

export default ClientAvatar;
